import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogActions, DialogContent, DialogTitle} from 'views/components';
import {Button, Typography} from 'views/components';
import {Translate} from 'views/module';

const RemoveAuth = (props) => {
  const [isDeleting, setIsDeleting] = React.useState(false);

  const onClose = props.onClose;
  const removeAuth = props.removeAuth;

  const onSubmit = () => {
    setIsDeleting(true);
    removeAuth();
  };

  return (
    <Dialog onClose={onClose}>
      <DialogTitle onClose={onClose}>
        <Translate expression='generic.ConfirmTheAction'/>
      </DialogTitle>
      <DialogContent>
        <Typography>
          <Translate expression='generic.DeleteConfirm'/>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant='outlined'
          onClick={onClose}
        >
          <Translate expression='generic.Close' />
        </Button>
        <Button
          color="error"
          variant="contained"
          onClick={onSubmit}
          loading={isDeleting}
        >
          <Translate expression='generic.Confirm'/>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

RemoveAuth.propTypes = {
  onClose: PropTypes.func.isRequired,
  removeAuth: PropTypes.func.isRequired,
};

export default React.memo(RemoveAuth);
